import Container from "../../components/container/container";
import MainBodySection from "../../components/main-body-section/main-body-section";
import Expertise from "../../components/expertise/expertise";
import SidebarEndcap from "../../components/sidebar-endcap/sidebar-endcap";

import { experienceP3 as experience, education } from "../../data/data";

import styles from "./styles.module.css";


export const P3 = () => {
  return (
    <Container
      sidebar={
        <>
          <SidebarEndcap />
        </>
      }
      body={
        <>
          <div className={styles.firstMainBodySection}>
            <MainBodySection {...experience} />
            <MainBodySection {...education} />
          </div>
        </>
      }

    />
  );
}

export default P3;
